import { connect } from 'react-redux'
import { RootState } from '../../../store'
import { PatientInfosStoreProps, PatientInfosDispatchProps } from './PatientInfos.model'
import { enabledFeaturesPreferencesSelector } from '../../../store/domain/me'
import { medicalEventUiActions } from '../../../store/ui/medicalEvents'
import { PatientInfos } from './PatientInfos.component'
import { clipboardActions } from '../../../store/clipboard'
import {
  dmpDomainActions,
  dmpIsReadySelector,
  dmpIsSendingSelector,
} from '../../../store/domain/dmp'
import { addError } from '../../../store/message'

const mapStateToProps = (state: RootState): PatientInfosStoreProps => ({
  enabledFeatures: enabledFeaturesPreferencesSelector(state),
  isDmpAvailable: dmpIsReadySelector(state),
  isDmpSending: dmpIsSendingSelector(state),
})
const mapDispatchToProps: PatientInfosDispatchProps = {
  selectMedicalEventDocument: medicalEventUiActions.selectMedicalEventDocument,
  copyTextToClipboard: clipboardActions.copyTextToClipboard,
  openDmp: dmpDomainActions.openDmp,
  addError
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)(PatientInfos)

export { withConnect as PatientInfos }
